<template><router-view /></template>
<script>
name: "peofileLayoutApp";
</script>
